import { claimReferral } from "@/lib/api";

// Section 7 — Referral capture. Fully client-side, never trusted for the actual
// credit amount (the backend derives the recipient from the session + is idempotent).
const REF_STORAGE_KEY = "snaggedify_ref_code";

export function captureRefFromUrl() {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem(REF_STORAGE_KEY, ref.toUpperCase());
  } catch { /* storage unavailable (private browsing) — ignore */ }
}

function getStoredRefCode() {
  try { return localStorage.getItem(REF_STORAGE_KEY) || ""; } catch { return ""; }
}

function clearStoredRefCode() {
  try { localStorage.removeItem(REF_STORAGE_KEY); } catch { /* ignore */ }
}

export async function maybeClaimReferral(isNewUser) {
  if (!isNewUser) return;
  const code = getStoredRefCode();
  if (!code) return;
  try {
    await claimReferral(code);
    clearStoredRefCode(); // only clear once the server has definitively answered
  } catch {
    /* network/server hiccup — leave the code stored so a later retry can still claim it */
  }
}
